// // // import React, { useState, useEffect } from 'react';
// // // import { motion } from 'framer-motion';

// // // export default function HomePage() {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [activeService, setActiveService] = useState(0);
  
// // //   // Existing services data remains the same

// // //   const metrics = [
// // //     { number: '99.9%', label: 'System Uptime' },
// // //     { number: '5x', label: 'Faster Deployments' },
// // //     { number: '300+', label: 'Projects Completed' },
// // //     { number: '24/7', label: 'Support Coverage' },
// // //   ];

// // //   const clients = [
// // //     'tech-company-1.svg',
// // //     'cloud-provider-2.svg',
// // //     'enterprise-3.svg',
// // //     'startup-4.svg',
// // //     'finance-company-5.svg',
// // //   ];

// // //   return (
// // //     <div className="min-h-screen flex flex-col">
// // //       {/* Enhanced Hero Section */}
// // //       <section className="relative bg-gradient-to-br from-sky-900 to-indigo-900 overflow-hidden">
// // //         <div className="absolute inset-0 opacity-20">
// // //           <div className="absolute w-[500px] h-[500px] bg-radial-gradient from-indigo-400 to-transparent blur-3xl opacity-30 animate-float"></div>
// // //         </div>
        
// // //         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
// // //           <div className="text-center">
// // //             <motion.div
// // //               initial={{ opacity: 0, y: 20 }}
// // //               animate={{ opacity: 1, y: 0 }}
// // //               transition={{ duration: 0.8 }}
// // //             >
// // //               <div className="inline-block mb-8 px-4 py-1 bg-white/10 backdrop-blur-sm rounded-full text-sm text-sky-200">
// // //                 DevOps Excellence Since 2018
// // //               </div>
// // //               <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white leading-tight">
// // //                 Transform Your
// // //                 <span className="bg-gradient-to-r from-indigo-400 to-sky-300 bg-clip-text text-transparent">
// // //                   <br /> DevOps Ecosystem
// // //                 </span>
// // //               </h1>
// // //               <p className="mt-6 text-xl text-sky-100 max-w-3xl mx-auto">
// // //                 Accelerate your digital transformation with enterprise-grade DevOps solutions, cloud-native architectures, and CI/CD excellence.
// // //               </p>
// // //               <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
// // //                 <motion.a
// // //                   whileHover={{ scale: 1.05 }}
// // //                   className="px-8 py-4 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg font-semibold shadow-lg transition-colors"
// // //                   href="#"
// // //                 >
// // //                   Start Free Consultation
// // //                 </motion.a>
// // //                 <motion.a
// // //                   whileHover={{ scale: 1.05 }}
// // //                   className="px-8 py-4 bg-transparent border-2 border-indigo-400 text-indigo-100 hover:bg-indigo-900/30 rounded-lg font-semibold shadow-lg transition-colors"
// // //                   href="#"
// // //                 >
// // //                   Watch Demo Video
// // //                 </motion.a>
// // //               </div>
// // //             </motion.div>
// // //           </div>

// // //           <motion.div 
// // //             initial={{ opacity: 0, scale: 0.9 }}
// // //             animate={{ opacity: 1, scale: 1 }}
// // //             transition={{ delay: 0.2 }}
// // //             className="mt-16 rounded-3xl overflow-hidden border border-white/10 bg-gradient-to-br from-indigo-800/30 to-sky-900/30 backdrop-blur-xl shadow-2xl"
// // //           >
// // //             <div className="aspect-video bg-gradient-to-tr from-indigo-400/10 to-sky-300/10 flex items-center justify-center">
// // //               <div className="text-center">
// // //                 <div className="text-white/50 text-sm mb-2">Interactive Platform Preview</div>
// // //                 <div className="h-12 w-12 rounded-full bg-indigo-500/20 animate-pulse flex items-center justify-center">
// // //                   <svg className="h-6 w-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
// // //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
// // //                   </svg>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </motion.div>
// // //         </div>
// // //       </section>

// // //       {/* Metrics Section */}
// // //       <section className="bg-gray-900 py-24">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
// // //             {metrics.map((metric, index) => (
// // //               <motion.div 
// // //                 key={index}
// // //                 initial={{ opacity: 0, y: 20 }}
// // //                 whileInView={{ opacity: 1, y: 0 }}
// // //                 viewport={{ once: true }}
// // //                 transition={{ delay: index * 0.1 }}
// // //                 className="p-6 bg-gray-800 rounded-xl shadow-lg"
// // //               >
// // //                 <div className="text-4xl font-bold text-indigo-400">{metric.number}</div>
// // //                 <div className="mt-2 text-gray-300 text-sm font-medium">{metric.label}</div>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Trusted By Section */}
// // //       <section className="py-16 bg-gray-800">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //           <div className="text-center mb-12">
// // //             <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wide">
// // //               Trusted by industry leaders
// // //             </h3>
// // //           </div>
// // //           <div className="flex flex-wrap justify-center gap-12 opacity-70 hover:opacity-100 transition-opacity">
// // //             {clients.map((client, index) => (
// // //               <motion.img
// // //                 key={index}
// // //                 src={`/clients/${client}`}
// // //                 alt="Client logo"
// // //                 className="h-12 object-contain grayscale hover:grayscale-0 transition-all"
// // //                 whileHover={{ scale: 1.1 }}
// // //               />
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Case Studies Section */}
// // //       <section className="py-24 bg-gray-900">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //           <div className="text-center mb-16">
// // //             <h2 className="text-3xl font-bold text-white mb-4">
// // //               Success Stories
// // //             </h2>
// // //             <p className="text-gray-400 max-w-2xl mx-auto">
// // //               Discover how we've helped organizations achieve DevOps transformation
// // //             </p>
// // //           </div>

// // //           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
// // //             {[1, 2, 3].map((caseStudy, index) => (
// // //               <motion.div 
// // //                 key={index}
// // //                 whileHover={{ y: -10 }}
// // //                 className="bg-gray-800 rounded-xl overflow-hidden shadow-xl"
// // //               >
// // //                 <div className="aspect-video bg-gradient-to-tr from-indigo-600/20 to-sky-600/20"></div>
// // //                 <div className="p-6">
// // //                   <div className="text-indigo-400 text-sm mb-2">Financial Services</div>
// // //                   <h3 className="text-xl font-semibold text-white mb-2">
// // //                     CI/CD Implementation for Global Bank
// // //                   </h3>
// // //                   <p className="text-gray-400 text-sm">
// // //                     Reduced deployment times by 80% and increased release frequency...
// // //                   </p>
// // //                   <a href="#" className="mt-4 inline-flex items-center text-indigo-400 hover:text-indigo-300 transition-colors">
// // //                     Read Case Study
// // //                     <svg className="ml-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
// // //                     </svg>
// // //                   </a>
// // //                 </div>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Methodology Section */}
// // //       <section className="py-24 bg-gray-800">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //           <div className="lg:text-center">
// // //             <h2 className="text-3xl font-bold text-white mb-4">
// // //               Our DevOps Framework
// // //             </h2>
// // //             <p className="text-gray-400 max-w-2xl mx-auto lg:text-center">
// // //               A structured approach to DevOps transformation
// // //             </p>
// // //           </div>

// // //           <div className="mt-16 space-y-16">
// // //             {['Plan', 'Build', 'Deploy', 'Operate', 'Monitor'].map((step, index) => (
// // //               <motion.div 
// // //                 key={step}
// // //                 initial={{ opacity: 0, x: -20 }}
// // //                 whileInView={{ opacity: 1, x: 0 }}
// // //                 viewport={{ once: true }}
// // //                 className="flex flex-col md:flex-row items-center gap-8 even:md:flex-row-reverse"
// // //               >
// // //                 <div className="md:w-1/3">
// // //                   <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-indigo-500 to-sky-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
// // //                     0{index + 1}
// // //                   </div>
// // //                 </div>
// // //                 <div className="md:w-2/3">
// // //                   <h3 className="text-2xl font-semibold text-white mb-4">{step} Phase</h3>
// // //                   <p className="text-gray-400">
// // //                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
// // //                   </p>
// // //                 </div>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Existing Services Section remains here */}

// // //       {/* CTA Section */}
// // //       <section className="relative bg-gradient-to-r from-indigo-600 to-sky-700 py-24">
// // //         <div className="absolute inset-0 opacity-10 bg-[url('')]"></div>
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
// // //           <h2 className="text-4xl font-bold text-white mb-6">
// // //             Ready to Transform Your DevOps?
// // //           </h2>
// // //           <p className="text-sky-100 text-xl mb-8 max-w-2xl mx-auto">
// // //             Schedule a free consultation with our experts and discover how we can optimize your development pipeline.
// // //           </p>
// // //           <motion.a
// // //             whileHover={{ scale: 1.05 }}
// // //             className="inline-block px-8 py-4 bg-white text-indigo-900 rounded-lg font-bold shadow-lg hover:shadow-xl transition-shadow"
// // //             href="#"
// // //           >
// // //             Start Your Journey Now
// // //           </motion.a>
// // //         </div>
// // //       </section>
// // //     </div>
// // //   )
// // // }

// // import React, { useState } from 'react';
// // import { motion, useScroll, useTransform } from 'framer-motion';
// // import { FiChevronRight, FiClock, FiCloud, FiCode, FiGithub, FiLinkedin, FiLock, FiMail, FiMapPin, FiMonitor, FiPhone, FiServer, FiTwitter, FiUsers } from 'react-icons/fi';

// // export default function HomePage() {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [activeService, setActiveService] = useState(0);

// //   // Data
// //   const services = [
// //     {
// //       title: "CI/CD Automation",
// //       icon: <FiCode className="w-8 h-8" />,
// //       description: "End-to-end pipeline implementation with quality gates",
// //       metrics: "200% faster release cycles"
// //     },
// //     {
// //       title: "Cloud Infrastructure",
// //       icon: <FiCloud className="w-8 h-8" />,
// //       description: "Multi-cloud management & optimization",
// //       metrics: "40% cost reduction average"
// //     },
// //     {
// //       title: "DevSecOps",
// //       icon: <FiLock className="w-8 h-8" />,
// //       description: "Security-first pipeline integration",
// //       metrics: "100% compliance assurance"
// //     },
// //     {
// //       title: "SRE Practices",
// //       icon: <FiServer className="w-8 h-8" />,
// //       description: "Enterprise-grade reliability engineering",
// //       metrics: "99.99% system availability"
// //     }
// //   ];

// //   const caseStudies = [
// //     {
// //       title: "Global FinTech Scaling",
// //       result: "5x deployment frequency",
// //       description: "Implemented Kubernetes-based CI/CD for 150+ microservices"
// //     },
// //     {
// //       title: "Healthcare Cloud Migration",
// //       result: "Zero downtime transition",
// //       description: "HIPAA-compliant AWS infrastructure with automated compliance checks"
// //     },
// //     {
// //       title: "E-commerce Optimization",
// //       result: "$2.8M annual savings",
// //       description: "Right-sized cloud resources with auto-scaling implementation"
// //     }
// //   ];

// //   return (
// //     <div className="min-h-screen bg-gray-900">
// //       {/* Header */}
// //       <motion.header 
// //         className="fixed w-full bg-gray-900/80 backdrop-blur-md z-50 border-b border-gray-800"
// //         initial={{ y: -100 }}
// //         animate={{ y: 0 }}
// //         transition={{ duration: 0.5 }}
// //       >
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="flex items-center justify-between h-20">
// //             <div className="flex items-center">
// //               <span className="text-2xl font-bold bg-gradient-to-r from-indigo-400 to-sky-400 bg-clip-text text-transparent">
// //                 DevOpsFlow
// //               </span>
// //               <nav className="hidden md:block ml-12">
// //                 <ul className="flex space-x-8">
// //                   <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Services</a></li>
// //                   <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Solutions</a></li>
// //                   <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Case Studies</a></li>
// //                   <li><a href="#" className="text-gray-300 hover:text-white transition-colors">About</a></li>
// //                 </ul>
// //               </nav>
// //             </div>
// //             <button className="hidden md:inline-flex items-center px-6 py-3 bg-gradient-to-r from-indigo-500 to-sky-600 text-white rounded-lg font-medium hover:opacity-90 transition-opacity">
// //               Schedule Call
// //             </button>
// //             <button 
// //               className="md:hidden p-2 text-gray-400 hover:text-white"
// //               onClick={() => setIsMenuOpen(!isMenuOpen)}
// //             >
// //               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// //               </svg>
// //             </button>
// //           </div>
// //         </div>

// //         {/* Mobile Menu */}
// //         {isMenuOpen && (
// //           <motion.div 
// //             className="md:hidden absolute w-full bg-gray-800"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //           >
// //             <div className="px-4 py-6 space-y-4">
// //               <a href="#" className="block text-gray-300 hover:text-white">Services</a>
// //               <a href="#" className="block text-gray-300 hover:text-white">Solutions</a>
// //               <a href="#" className="block text-gray-300 hover:text-white">Case Studies</a>
// //               <a href="#" className="block text-gray-300 hover:text-white">About</a>
// //               <button className="w-full py-3 bg-gradient-to-r from-indigo-500 to-sky-600 text-white rounded-lg">
// //                 Schedule Call
// //               </button>
// //             </div>
// //           </motion.div>
// //         )}
// //       </motion.header>

// //       {/* Hero Section */}
// //       <section className="pt-32 pb-24 px-4 sm:px-6 lg:px-8">
// //         <div className="max-w-7xl mx-auto text-center">
// //           <motion.h1 
// //             className="text-5xl sm:text-6xl font-bold text-white mb-8"
// //             initial={{ opacity: 0, y: 20 }}
// //             animate={{ opacity: 1, y: 0 }}
// //           >
// //             Accelerate Your Cloud-Native
// //             <span className="block mt-4 bg-gradient-to-r from-indigo-400 to-sky-300 bg-clip-text text-transparent">
// //               Transformation
// //             </span>
// //           </motion.h1>
// //           <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-12">
// //             Enterprise DevOps solutions that unify development, operations, and security teams through automated workflows and intelligent observability.
// //           </p>
// //           <div className="flex flex-col sm:flex-row gap-4 justify-center">
// //             <motion.button 
// //               whileHover={{ scale: 1.05 }}
// //               className="px-8 py-4 bg-gradient-to-r from-indigo-500 to-sky-600 text-white rounded-lg font-semibold flex items-center gap-2"
// //             >
// //               <FiMonitor className="w-5 h-5" />
// //               Book Platform Demo
// //             </motion.button>
// //             <button className="px-8 py-4 border border-gray-700 text-gray-300 hover:border-indigo-400 hover:text-white rounded-lg transition-colors">
// //               View Client Success Stories
// //             </button>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Metrics Section */}
// //       <section className="py-16 bg-gray-800">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
// //             {[
// //               { value: '3.2x', label: 'Faster Deployment' },
// //               { value: '99.95%', label: 'Uptime SLA' },
// //               { value: '150+', label: 'Projects Completed' },
// //               { value: '40%', label: 'Cost Reduction Avg.' }
// //             ].map((metric, index) => (
// //               <motion.div 
// //                 key={index}
// //                 className="p-6 bg-gray-700/30 rounded-xl"
// //                 initial={{ opacity: 0 }}
// //                 whileInView={{ opacity: 1 }}
// //                 transition={{ delay: index * 0.1 }}
// //               >
// //                 <div className="text-3xl font-bold text-indigo-400">{metric.value}</div>
// //                 <div className="mt-2 text-gray-300 text-sm">{metric.label}</div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Services Section */}
// //       <section className="py-24 px-4 sm:px-6 lg:px-8">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="text-center mb-16">
// //             <h2 className="text-3xl font-bold text-white mb-4">Enterprise DevOps Solutions</h2>
// //             <p className="text-gray-400 max-w-2xl mx-auto">
// //               Full lifecycle services from cloud architecture to production monitoring
// //             </p>
// //           </div>
          
// //           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
// //             {services.map((service, index) => (
// //               <motion.div 
// //                 key={index}
// //                 className="p-8 bg-gray-800 rounded-2xl hover:bg-gray-700/50 transition-colors group"
// //                 whileHover={{ y: -10 }}
// //               >
// //                 <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-sky-600 rounded-lg flex items-center justify-center text-white mb-6">
// //                   {service.icon}
// //                 </div>
// //                 <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
// //                 <p className="text-gray-400 mb-4">{service.description}</p>
// //                 <div className="text-sm text-indigo-400 flex items-center gap-2">
// //                   <FiClock className="w-4 h-4" />
// //                   {service.metrics}
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Case Studies Section */}
// //       <section className="py-24 bg-gray-800">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="text-center mb-16">
// //             <h2 className="text-3xl font-bold text-white mb-4">Transformative Impact</h2>
// //             <p className="text-gray-400 max-w-2xl mx-auto">
// //               Real-world results from our DevOps implementations
// //             </p>
// //           </div>
          
// //           <div className="grid md:grid-cols-3 gap-8">
// //             {caseStudies.map((caseStudy, index) => (
// //               <motion.div 
// //                 key={index}
// //                 className="bg-gray-900 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow"
// //                 whileHover={{ y: -5 }}
// //               >
// //                 <div className="h-48 bg-gradient-to-r from-indigo-600/20 to-sky-600/20"></div>
// //                 <div className="p-8">
// //                   <div className="text-indigo-400 text-sm mb-2">Success Story</div>
// //                   <h3 className="text-xl font-semibold text-white mb-2">{caseStudy.title}</h3>
// //                   <p className="text-gray-400 mb-4">{caseStudy.description}</p>
// //                   <div className="text-sm text-indigo-400 flex items-center gap-2">
// //                     <FiChevronRight className="w-4 h-4" />
// //                     {caseStudy.result}
// //                   </div>
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <footer className="bg-gray-800 border-t border-gray-700">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
// //           <div className="grid md:grid-cols-4 gap-8">
// //             <div>
// //               <h3 className="text-white text-lg font-semibold mb-4">DevOpsFlow</h3>
// //               <p className="text-gray-400 text-sm">
// //                 Accelerating digital transformation through intelligent automation
// //               </p>
// //             </div>
// //             <div>
// //               <h4 className="text-white font-medium mb-4">Solutions</h4>
// //               <ul className="space-y-2">
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">CI/CD Automation</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">Cloud Migration</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">Infrastructure as Code</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">SRE Implementation</a></li>
// //               </ul>
// //             </div>
// //             <div>
// //               <h4 className="text-white font-medium mb-4">Company</h4>
// //               <ul className="space-y-2">
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">About Us</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">Careers</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">Blog</a></li>
// //                 <li><a href="#" className="text-gray-400 hover:text-white text-sm">Contact</a></li>
// //               </ul>
// //             </div>
// //             <div>
// //               <h4 className="text-white font-medium mb-4">Contact</h4>
// //               <ul className="space-y-2 text-sm text-gray-400">
// //                 <li className="flex items-center gap-2">
// //                   <FiMapPin className="w-4 h-4" />
// //                   San Francisco, CA
// //                 </li>
// //                 <li className="flex items-center gap-2">
// //                   <FiMail className="w-4 h-4" />
// //                   hello@devopsflow.com
// //                 </li>
// //                 <li className="flex items-center gap-2">
// //                   <FiPhone className="w-4 h-4" />
// //                   (415) 555-0139
// //                 </li>
// //               </ul>
// //             </div>
// //           </div>
// //           <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
// //             <div className="text-gray-400 text-sm mb-4 md:mb-0">
// //               © 2024 DevOpsFlow. All rights reserved.
// //             </div>
// //             <div className="flex space-x-6">
// //               <a href="#" className="text-gray-400 hover:text-white">
// //                 <FiTwitter className="w-5 h-5" />
// //               </a>
// //               <a href="#" className="text-gray-400 hover:text-white">
// //                 <FiLinkedin className="w-5 h-5" />
// //               </a>
// //               <a href="#" className="text-gray-400 hover:text-white">
// //                 <FiGithub className="w-5 h-5" />
// //               </a>
// //             </div>
// //           </div>
// //         </div>
// //       </footer>

// //       {/* Floating CTA */}
// //       <motion.div 
// //         className="fixed bottom-8 right-8 bg-gradient-to-r from-indigo-500 to-sky-600 p-4 rounded-full shadow-lg cursor-pointer"
// //         whileHover={{ scale: 1.05 }}
// //       >
// //         <FiMail className="w-6 h-6 text-white" />
// //       </motion.div>
// //     </div>
// //   )
// // }

// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { FiChevronRight, FiClock, FiCloud, FiCode, FiLock, FiMail, FiMapPin, FiMonitor, FiPhone, FiServer, FiUsers, FiTwitter, FiLinkedin, FiGithub } from 'react-icons/fi';

// export default function HomePage() {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   // Vibrant color scheme
//   const colors = {
//     primary: 'bg-gradient-to-r from-electricindigo-500 to-magenta-500',
//     secondary: 'bg-gradient-to-r from-cyan-400 to-electricindigo-500',
//     accent: 'bg-gradient-to-r from-magenta-400 to-pink-500'
//   };

//   const services = [
//     {
//       title: "CI/CD Automation",
//       icon: <FiCode className="w-8 h-8" />,
//       description: "End-to-end pipeline implementation with quality gates",
//       color: 'from-electricindigo-400 to-cyan-400'
//     },
//     {
//       title: "Cloud Infrastructure",
//       icon: <FiCloud className="w-8 h-8" />,
//       description: "Multi-cloud management & optimization",
//       color: 'from-magenta-400 to-pink-400'
//     },
//     {
//       title: "DevSecOps",
//       icon: <FiLock className="w-8 h-8" />,
//       description: "Security-first pipeline integration",
//       color: 'from-cyan-400 to-electricindigo-400'
//     },
//     {
//       title: "SRE Practices",
//       icon: <FiServer className="w-8 h-8" />,
//       description: "Enterprise-grade reliability engineering",
//       color: 'from-pink-400 to-magenta-400'
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-galaxyBlack">
//       {/* Vibrant Header */}
//       <motion.header 
//         className="fixed w-full bg-galaxyBlack/90 backdrop-blur-md z-50 border-b border-electricindigo-800"
//         initial={{ y: -100 }}
//         animate={{ y: 0 }}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-20">
//             <div className="flex items-center">
//               <span className="text-2xl font-bold bg-gradient-to-r from-electricindigo-400 to-cyan-400 bg-clip-text text-transparent">
//                 DevOpsNova
//               </span>
//               <nav className="hidden md:block ml-12">
//                 <ul className="flex space-x-8">
//                   <li><a href="#" className="text-electricindigo-200 hover:text-cyan-300 transition-colors">Services</a></li>
//                   <li><a href="#" className="text-electricindigo-200 hover:text-cyan-300 transition-colors">Solutions</a></li>
//                   <li><a href="#" className="text-electricindigo-200 hover:text-cyan-300 transition-colors">Case Studies</a></li>
//                   <li><a href="#" className="text-electricindigo-200 hover:text-cyan-300 transition-colors">About</a></li>
//                 </ul>
//               </nav>
//             </div>
//             <button className={`hidden md:inline-flex items-center px-6 py-3 ${colors.primary} text-white rounded-xl font-medium hover:shadow-glow transition-all`}>
//               Schedule Call
//             </button>
//           </div>
//         </div>
//       </motion.header>

//       {/* Electric Hero Section */}
//       <section className="pt-40 pb-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-galaxyBlack to-electricindigo-900/30">
//         <div className="max-w-7xl mx-auto text-center">
//           <motion.h1 
//             className="text-5xl sm:text-6xl font-bold text-white mb-8"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//           >
//             Ignite Your
//             <span className="block mt-4 bg-gradient-to-r from-magenta-400 to-cyan-400 bg-clip-text text-transparent">
//               DevOps Evolution
//             </span>
//           </motion.h1>
//           <p className="text-xl text-electricindigo-200 max-w-3xl mx-auto mb-12">
//             Revolutionize your workflow with neon-bright automation and cyberpunk-inspired infrastructure solutions
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <motion.button 
//               whileHover={{ scale: 1.05 }}
//               className={`px-8 py-4 ${colors.secondary} text-white rounded-xl font-semibold flex items-center gap-2 shadow-electricGlow`}
//             >
//               <FiMonitor className="w-5 h-5" />
//               Start Free Trial
//             </motion.button>
//             <button className="px-8 py-4 border-2 border-electricindigo-500 text-electricindigo-300 hover:border-cyan-400 hover:text-cyan-300 rounded-xl transition-all">
//               Watch Tech Demo
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Glowing Metrics */}
//       <section className="py-16 bg-galaxyBlack">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//             {[
//               { value: '10x', label: 'Faster Deployment' },
//               { value: '100%', label: 'Uptime Guarantee' },
//               { value: '∞', label: 'Scalability' },
//               { value: '1ms', label: 'Response Time' }
//             ].map((metric, index) => (
//               <motion.div 
//                 key={index}
//                 className="p-6 bg-electricindigo-900/20 rounded-2xl border border-electricindigo-800/50 hover:border-cyan-400/30 transition-all"
//                 whileHover={{ scale: 1.05 }}
//               >
//                 <div className="text-4xl font-bold bg-gradient-to-r from-magenta-400 to-cyan-400 bg-clip-text text-transparent">
//                   {metric.value}
//                 </div>
//                 <div className="mt-2 text-electricindigo-300 text-sm">{metric.label}</div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Cyber Services Grid */}
//       <section className="py-24 px-4 sm:px-6 lg:px-8 bg-galaxyBlack">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl font-bold text-white mb-4">Neon-Bright Solutions</h2>
//             <p className="text-electricindigo-300 max-w-2xl mx-auto">
//               Next-gen DevOps services glowing with digital potential
//             </p>
//           </div>
          
//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {services.map((service, index) => (
//               <motion.div 
//                 key={index}
//                 className="p-8 bg-electricindigo-900/20 rounded-3xl border border-electricindigo-800/50 hover:border-cyan-400/50 transition-all group"
//                 whileHover={{ y: -10 }}
//               >
//                 <div className={`w-14 h-14 bg-gradient-to-r ${service.color} rounded-xl flex items-center justify-center text-white mb-6`}>
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
//                 <p className="text-electricindigo-300 mb-4">{service.description}</p>
//                 <div className="text-sm bg-gradient-to-r from-cyan-400 to-electricindigo-400 bg-clip-text text-transparent flex items-center gap-2">
//                   <FiClock className="w-4 h-4" />
//                   Instant Activation
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Holographic Footer */}
//       <footer className="bg-galaxyBlack border-t border-electricindigo-800/50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
//           <div className="grid md:grid-cols-4 gap-8">
//             <div>
//               <h3 className="text-white text-lg font-semibold mb-4">DevOpsNova</h3>
//               <p className="text-electricindigo-300 text-sm">
//                 Lighting up the future of cloud automation
//               </p>
//             </div>
//             <div>
//               <h4 className="text-electricindigo-200 font-medium mb-4">Solutions</h4>
//               <ul className="space-y-2">
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Quantum CI/CD</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Neural Cloud</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">AI Ops</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Blockchain DevOps</a></li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="text-electricindigo-200 font-medium mb-4">Company</h4>
//               <ul className="space-y-2">
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Cyber Lab</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Neon Careers</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Hologram Blog</a></li>
//                 <li><a href="#" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Neural Network</a></li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="text-electricindigo-200 font-medium mb-4">Contact</h4>
//               <ul className="space-y-2 text-sm text-electricindigo-300">
//                 <li className="flex items-center gap-2">
//                   <FiMapPin className="w-4 h-4 text-cyan-400" />
//                   Neon Valley, DV 404
//                 </li>
//                 <li className="flex items-center gap-2">
//                   <FiMail className="w-4 h-4 text-cyan-400" />
//                   pulse@devopsnova.ai
//                 </li>
//                 <li className="flex items-center gap-2">
//                   <FiPhone className="w-4 h-4 text-cyan-400" />
//                   +1-555-SYNTAX
//                 </li>
//               </ul>
//             </div>
//           </div>
//           <div className="border-t border-electricindigo-800/50 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
//             <div className="text-electricindigo-400 text-sm mb-4 md:mb-0">
//               © 2024 DevOpsNova. All circuits reserved.
//             </div>
//             <div className="flex space-x-6">
//               <a href="#" className="text-electricindigo-300 hover:text-cyan-300">
//                 <FiTwitter className="w-5 h-5" />
//               </a>
//               <a href="#" className="text-electricindigo-300 hover:text-cyan-300">
//                 <FiLinkedin className="w-5 h-5" />
//               </a>
//               <a href="#" className="text-electricindigo-300 hover:text-cyan-300">
//                 <FiGithub className="w-5 h-5" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>

//       {/* Cyber Glow CTA */}
//       <motion.div 
//         className="fixed bottom-8 right-8 bg-gradient-to-r from-magenta-400 to-cyan-400 p-4 rounded-full shadow-cyberGlow cursor-pointer"
//         whileHover={{ scale: 1.1 }}
//       >
//         <FiMail className="w-6 h-6 text-galaxyBlack" />
//       </motion.div>
//     </div>
//   )
// }

import React, { useState } from 'react';
import WhyChooseSection from './WhyChooseUs';
import { FiChevronRight, FiClock, FiCloud, FiCode, FiLock, FiMail, FiMapPin, FiMonitor, FiPhone, FiServer, FiUsers, FiTwitter, FiLinkedin, FiGithub } from 'react-icons/fi';
import ServicesSection from './ServicesPage';
import logo from '../assets/capitalPlus.png'
import { motion } from 'framer-motion';
import heroImg from '../assets/devops2.svg'
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
export default function() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('services');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navigation */}
      <Header />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-sky-400 via-sky-600 to-indigo-700 overflow-hidden">
  <div className="absolute inset-0 opacity-10 bg-[url('')]"></div>
  
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28">
    <div className="grid lg:grid-cols-2 gap-16 items-center">
      {/* Text Content */}
      <div className="relative z-10">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight"
        >
          <span className="bg-gradient-to-r from-indigo-900 to-indigo-900 bg-clip-text text-transparent">
            Transform Your
          </span>
          <br />
          <span className="text-white">DevOps Ecosystem</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mt-6 text-lg md:text-xl text-sky-100 max-w-xl"
        >
          Accelerate delivery cycles with intelligent automation, cloud-native architectures, 
          and seamless CI/CD pipelines powered by enterprise-grade DevOps solutions.
        </motion.p>

        <motion.div 
          className="mt-10 flex flex-wrap gap-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
         
            <Link to='/contact'  className="px-8 py-4 bg-gradient-to-r from-indigo-500 to-sky-900 text-white rounded-xl font-semibold 
                      hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
            Start Free Trial
          
          </Link>
          
          {/* <a 
            href="#"
            className="px-8 py-4 border-2 border-sky-300 text-sky-50 rounded-xl font-semibold
                      hover:bg-sky-900/30 hover:border-sky-400 transition-all duration-300"
          >
            Watch Demo Video
          </a> */}
        </motion.div>
      </div>

      {/* Image Section */}
      <motion.div 
        className="relative"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="absolute -top-8 -right-8 w-64 h-64 bg-indigo-500 rounded-full mix-blend-screen opacity-20 blur-3xl"></div>
        
        <div className="relative bg-gradient-to-br from-indigo-900/30 to-sky-900/40 rounded-3xl p-8 
                       backdrop-blur-xl border border-sky-800/50 shadow-2xl">
          <div className="aspect-w-16 aspect-h-9 bg-sky-900/20 rounded-2xl overflow-hidden">
            <img 
              src={heroImg} 
              alt="DevOps Dashboard Preview"
              className="object-cover object-left-top animate-float"
            />
          </div>
          
          {/* Decorative Elements */}
          <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-sky-600 rounded-full blur-2xl opacity-30"></div>
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-indigo-500 rounded-full blur-2xl opacity-30"></div>
        </div>
      </motion.div>
    </div>
  </div>
</div>

      {/* Services Section */}
      <ServicesSection />

      {/* Why Choose Us Section */}
      <WhyChooseSection />
             {/* Holographic Footer */}
            <Footer />
      </div>
     
  )
}